<!-- Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. -->
<!-- Hover over -->
<ng-container *ngIf="hoverOverData$ | async as hoverOverData">
	<div *ngIf="hoverOverData.length" class="hover-over-contents">
		<div class="top-actions-container">
			<button class="link-btn" mat-button color="primary" (click)="onShowHoverOverSettings()">
				{{ AppStrings.HOVER_OVER_ACTION_EDIT_FIELDS }}
			</button>
			<button class="link-btn" mat-button color="primary" (click)="onTurnOffHoverOver()">
				{{ AppStrings.HOVER_OVER_ACTION_DISABLE }}
			</button>
		</div>
		<ng-container
			*ngFor="let hoverOverItem of hoverOverData"
			[ngTemplateOutlet]="hoverItem"
			[ngTemplateOutletContext]="{ item: hoverOverItem }"
		></ng-container>

		<ng-container *ngIf="settingsData?.displayImageAttachmentsCount">
			<div class="hover-over-option">
				<div class="option-title">
					{{ AppStrings.TOOLTIP_CONTENT_OPTION_ATTACHMENTS_NUMBER }}
				</div>
				<div class="option-content" *ngIf="!isLoadingAttachmentsData; else spinner">
					{{ imageAttachmentsCount }}
				</div>
			</div>
		</ng-container>
	</div>
</ng-container>

<ng-template #hoverItem let-item="item">
	<div class="hover-over-option">
		<div class="option-title" *ngIf="item.label">
			{{ item.label }}
		</div>
		<div class="option-content" *ngIf="item.data">
			{{ item.data }}
		</div>
	</div>
</ng-template>

<ng-template #spinner>
	<mat-spinner class="attachment-loader" [diameter]="20"></mat-spinner>
</ng-template>
